import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import classnames from "classnames";
import { Card, CardBody, Col, Container, Row, Label, Progress, Nav, TabContent, TabPane } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';
import { createDeepClone } from "../utils/index";
import CardLoader from "../components/CardLoader";

import { useDispatch, useSelector } from "react-redux";
import * as ineRequestActions from "../actions/IneRequestActions";

const IneRequestAddScreen  = () => {
    const { register, clearErrors, reset, trigger, formState: { errors } } = useForm({mode: 'all'});

    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const loading = useSelector((state) => state.ine.loadingFBO);
    const fbo = useSelector((state) => state.ine.fbo);
    
    const [fboState, setFBOState] = React.useState(fbo);
    const [progressbarvalue, setprogressbarvalue] = React.useState(0);
    const [activeTab, setactiveTab] = React.useState(1);
    const [passedSteps, setPassedSteps] = React.useState([1]);

    React.useEffect(() => {
        dispatch(ineRequestActions.loadIneRequest(null, navigate));
    }, []);

    React.useEffect(() => {
        setFBOState(fbo);

        if(fbo != null) {
            reset(fbo.ineRequest);
        }

        clearErrors();
    }, [fbo]);

    const onIneRequestChange = (name, value) => {
        var copy_fboState = createDeepClone(fboState);

        if(value) {
            copy_fboState.ineRequest[name] = value;
        }
        else if(value === false) {
            copy_fboState.ineRequest[name] = false;
        }
        else {
            copy_fboState.ineRequest[name] = null;
        }

        setFBOState(copy_fboState);
    }

    const onNext = async () => {
        const valid = true;
        if(valid) {
            setactiveTab(2);
            setPassedSteps([...passedSteps, 2]);
            setprogressbarvalue(100);
        }
    };

    const onBack = () => {
        setactiveTab(1);
        setprogressbarvalue(0);
    };

    const onSubmit = async () => {
        const valid = await trigger();
        if(valid) {
            dispatch(ineRequestActions.saveIneRequest(fboState, '', '', navigate));
        }
    };

    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={"Add INE Request"} />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <CardLoader loading={loading} />
                                <CardBody>
                                    <div className="text-center pt-3 pb-4 mb-1">
                                        <h5>Create New INE Request</h5>
                                    </div>
                                    <div className="progress-nav mb-4">
                                        <Progress value={progressbarvalue} style={{ height: "1px" }} />
                                        <Nav className="nav-pills progress-bar-tab custom-nav" role="tablist">
                                            <li className="nav-item">
                                                <button type="button"
                                                    className={classnames({ active: activeTab === 1, done: activeTab <= 2 && activeTab >= 0 }, "rounded-pill nav-link")}
                                                >1</button>
                                            </li>
                                            <li className="nav-item">
                                                <button type="button"
                                                    className={classnames({ active: activeTab === 2, done: activeTab <= 2 && activeTab > 1 }, "rounded-pill nav-link")}
                                                >2</button>
                                            </li>
                                        </Nav>
                                    </div>
                                    <TabContent activeTab={activeTab}>
                                        <TabPane tabId={1}>
                                            <Row className="gy-2">
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Ticket #</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(fboState && fboState.ineRequest.requestNumber) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Status</Label>
                                                    <input className="form-control" readOnly={true}
                                                        value={(fboState && fboState.ineRequest.status) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={6} md={6}>
                                                    <Label className="form-label">Remarks</Label>
                                                    <input type="text" maxLength={512} className="form-control"
                                                        value={(fboState && fboState.ineRequest.description) || ""}
                                                        onChange={e => onIneRequestChange("description", e.target.value)}
                                                    />
                                                </Col>
                                                {/* <Col xxl={4} md={6}>
                                                    <Label className="form-label">Scope<span className="required">*</span></Label>
                                                    <select className={`form-select ${errors.scopeId ? "is-invalid" : ""}`}
                                                        title={errors.scopeId?.message}
                                                        value={(fboState && fboState.ineRequest.scopeId) || ""}
                                                        {...register("scopeId", { required: "Scope is required", validate: (value) => (value > 0 || "Scope is required") })}
                                                        onChange={e => onScopeChange(e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {fboState && fboState.testingScopeList.map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.id}>{item.name}</option>
                                                            );
                                                        })}
                                                    </select>
                                                </Col> */}
                                            </Row>
                                            <div className="d-flex align-items-start gap-3 mt-4">
                                                <button
                                                    disabled={loading}
                                                    type="button"
                                                    className="btn btn-primary btn-label right ms-auto nexttab nexttab"
                                                    onClick={onNext}
                                                >
                                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                                    Next
                                                </button>
                                            </div>
                                        </TabPane>
                                        <TabPane tabId={2}>
                                            <Row className="gy-2">
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">CRM Name<span className="required">*</span></Label>
                                                    <select className={`form-select ${errors.crmName ? "is-invalid" : ""}`}
                                                        title={errors.crmName?.message}
                                                        value={(fboState && fboState.ineRequest.crmName) || ""}
                                                        {...register("crmName", { required: "CRM Name is required" })}
                                                        onChange={e => onIneRequestChange("crmName", e.target.value)}
                                                    >
                                                        <option value="">...</option>
                                                        {fboState && fboState.crmList.map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.crmNameIni}>{item.crmLabel}</option>
                                                            );
                                                        })}
                                                    </select>
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Invoice Country<span className="required">*</span></Label>
                                                    <select className={`form-select ${errors.crmCountry ? "is-invalid" : ""}`}
                                                        title={errors.crmCountry?.message}
                                                        value={(fboState && fboState.ineRequest.crmCountry) || ""}
                                                        {...register("crmCountry", { required: "Invoice Country is required" })}
                                                        onChange={e => onIneRequestChange("crmCountry", e.target.value)}
                                                    >
                                                        <option value="">...</option>
                                                        {fboState && fboState.crmCountryList.filter(x => x.crmNameIni == fboState.ineRequest.crmName).map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.countryName}>{item.countryLabel}</option>
                                                            );
                                                        })}
                                                    </select>
                                                </Col>
                                            </Row>
                                            <div className="d-flex align-items-start gap-3 mt-4">
                                                <button
                                                    disabled={loading}
                                                    type="button"
                                                    className="btn btn-link text-decoration-none btn-label previestab"
                                                    onClick={onBack}
                                                >
                                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
                                                    Back
                                                </button>
                                                <button
                                                    disabled={loading}
                                                    type="button"
                                                    className="btn btn-primary btn-label right ms-auto nexttab nexttab"
                                                    onClick={onSubmit}
                                                >
                                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                                    Submit
                                                </button>
                                            </div>
                                        </TabPane>
                                    </TabContent>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default IneRequestAddScreen;
